export default "__VITE_ASSET__DyCSE1Y$__"